/** @module csi/image/ImageEditorZoomout **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("imagezoomout", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for rotating
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorZoomout",
				m_onAction: "zoom",
				value: -0.1
			});
			this.defAction.setMaterialIcon("zoom_out");
			this.defAction.resolve();
		}
	});
});